import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M.519 4.193 4.47 6.008a1.3 1.3 0 0 0 .53.117 1.3 1.3 0 0 0 .537-.119l3.947-1.837a.887.887 0 0 0 0-1.612L5.526.741a1.27 1.27 0 0 0-1.069 0L.516 2.58a.889.889 0 0 0 0 1.613Z"
    }, null, -1),
    createElementVNode("path", {
      fill: "currentColor",
      d: "M8.774 6.144 5.106 7.851a.24.24 0 0 1-.209 0L1.212 6.159a.75.75 0 1 0-.626 1.363L4.27 9.215a1.75 1.75 0 0 0 1.469 0L9.407 7.5a.75.75 0 1 0-.633-1.36Z"
    }, null, -1)
  ]));
}
const Duplicate = { render };
export {
  Duplicate as default,
  render
};
//# sourceMappingURL=Duplicate.svg.js.map
